export default [
  {
    date: 1517003602441,
    row: 17,
    col: 10,
    squares: [
      [17, 5, "#FF9900"],
      [17, 6, "#FF9900"],
      [16, 5, "#FF9900"],
      [16, 6, "#FF9900"],
      [15, 5, "#FF9900"],
      [15, 6, "#FF9900"],
      [14, 1, "#5CB85C"],
      [14, 2, "#FF0000"],
      [14, 3, "#5CB85C"],
      [14, 4, "#5CB85C"],
      [14, 7, "#5CB85C"],
      [14, 8, "#5CB85C"],
      [14, 9, "#5CB85C"],
      [14, 10, "#5CB85C"],
      [14, 5, "#5CB85C"],
      [14, 6, "#FF0000"],
      [13, 5, "#5CB85C"],
      [13, 6, "#5CB85C"],
      [12, 5, "#5CB85C"],
      [12, 6, "#5CB85C"],
      [11, 5, "#FF0000"],
      [11, 6, "#5CB85C"],
      [10, 5, "#5CB85C"],
      [10, 6, "#FF0000"],
      [9, 5, "#5CB85C"],
      [9, 6, "#5CB85C"],
      [8, 5, "#5CB85C"],
      [8, 6, "#5CB85C"],
      [7, 5, "#FF0000"],
      [7, 6, "#5CB85C"],
      [6, 5, "#5CB85C"],
      [6, 6, "#FF0000"],
      [5, 5, "#5CB85C"],
      [5, 6, "#5CB85C"],
      [4, 5, "#5CB85C"],
      [4, 6, "#5CB85C"],
      [13, 2, "#5CB85C"],
      [12, 3, "#5CB85C"],
      [11, 4, "#5CB85C"],
      [10, 4, "#5CB85C"],
      [10, 3, "#5CB85C"],
      [10, 2, "#FF0000"],
      [10, 1, "#5CB85C"],
      [8, 3, "#5CB85C"],
      [9, 2, "#5CB85C"],
      [8, 4, "#FF0000"],
      [7, 4, "#5CB85C"],
      [6, 4, "#5CB85C"],
      [6, 2, "#FF0000"],
      [6, 3, "#5CB85C"],
      [6, 1, "#5CB85C"],
      [5, 2, "#5CB85C"],
      [4, 3, "#5CB85C"],
      [3, 4, "#5CB85C"],
      [3, 5, "#FF0000"],
      [3, 6, "#5CB85C"],
      [2, 5, "#5CB85C"],
      [2, 6, "#FF0000"],
      [3, 7, "#5CB85C"],
      [4, 8, "#FF0000"],
      [6, 9, "#5CB85C"],
      [5, 9, "#5CB85C"],
      [6, 10, "#5CB85C"],
      [6, 8, "#5CB85C"],
      [6, 7, "#5CB85C"],
      [7, 7, "#5CB85C"],
      [8, 8, "#FF0000"],
      [9, 9, "#5CB85C"],
      [10, 10, "#5CB85C"],
      [10, 9, "#5CB85C"],
      [10, 8, "#5CB85C"],
      [11, 7, "#5CB85C"],
      [10, 7, "#5CB85C"],
      [12, 8, "#FF0000"],
      [13, 9, "#5CB85C"],
      [9, 4, "#5CB85C"],
      [9, 3, "#FF0000"],
      [13, 4, "#5CB85C"],
      [12, 4, "#FF0000"],
      [13, 3, "#FF0000"],
      [12, 7, "#5CB85C"],
      [13, 7, "#FF0000"],
      [13, 8, "#5CB85C"],
      [9, 8, "#5CB85C"],
      [8, 7, "#5CB85C"],
      [9, 7, "#FF0000"],
      [4, 7, "#5CB85C"],
      [5, 8, "#5CB85C"],
      [5, 7, "#FF0000"],
      [4, 4, "#FF0000"],
      [5, 4, "#5CB85C"],
      [5, 3, "#FF0000"],
      [8, 1, "#FF0000"],
      [12, 1, "#FF0000"],
      [16, 1, "#FF0000"],
      [16, 10, "#FF0000"],
      [12, 10, "#FF0000"],
      [8, 10, "#FF0000"],
      [7, 1, "#D9D9D9"],
      [11, 1, "#D9D9D9"],
      [15, 1, "#D9D9D9"],
      [7, 10, "#D9D9D9"],
      [11, 10, "#D9D9D9"],
      [15, 10, "#D9D9D9"],
      [1, 5, "#FFFF00"],
      [1, 6, "#FFFF00"],
      [3, 8, "#FFFF00"],
      [4, 9, "#FFFF00"],
      [1, 8, "#FFFF00"],
      [1, 9, "#FFFF00"],
      [3, 3, "#FFFF00"],
      [4, 2, "#FFFF00"],
      [1, 2, "#FFFF00"],
      [1, 3, "#FFFF00"],
    ],
  },
];
